export const MAP_LAST_USED_LOCAL_STORAGE_KEY = 'map_last_used_position';
